import {
  PHRASE_SEARCH, PHRASE_SEARCH_SUCCESS, PHRASE_SEARCH_FAILURE, PHRASE_CLEAR,
  PHRASE_TYPE_SEARCH, PHRASE_TYPE_SEARCH_FAILURE, PHRASE_TYPE_SEARCH_SUCCESS,
  PHRASE_SAVE, PHRASE_SAVE_SUCCESS, PHRASE_SAVE_FAILURE,
  PHRASE_USE, PHRASE_USE_SUCCESS, PHRASE_USE_FAILURE,
  PHRASE_DELETE, PHRASE_DELETE_SUCCESS, PHRASE_DELETE_FAILURE
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    phrases: {},
    phraseTypes: {},
    uncategorizedPhrases: null,
    phrasesCurrentPage: null,
    phrasesNextPage: null,
    phrasesTotalCount: 0,
    phrasesNotify: null,
    phraseLists: {}
  },
  getters: {
    phrases: state => {
      return state.phrases
    },
    phraseTypes: state => {
      return state.phraseTypes
    },
    uncategorizedPhrases: state => {
      return state.uncategorizedPhrases
    },
    phrasesCurrentPage: state => {
      return state.phrasesCurrentPage
    },
    phrasesNextPage: state => {
      return state.phrasesNextPage
    },
    phrasesTotalCount: state => {
      return state.phrasesTotalCount
    },
    /** 通知 */
    phrasesNotify: state => {
      return state.phrasesNotify
    },
    phraseLists: state => {
      return state.phraseLists
    }
  },
  actions: {
    [PHRASE_SEARCH] ({dispatch, state, commit}, params) {
      var url = '/phrases/select_phrases'
      var isCombobox = false
      var loadparams = true
      var callback = () => {}
      var data = {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if (params.type === 'combobox') {
          isCombobox = true
        }
        if (params.loadparams) {
          loadparams = params.loadparams
        }
        if (params.callback) {
          callback = params.callback
        }
        if (params.data) {
          data = params.data
        }
        if (params.mode) {
          data['mode'] = params.mode
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PHRASE_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            res.data.isCombobox = isCombobox
            commit(PHRASE_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PHRASE_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(PHRASE_CLEAR)
      }, sleep)
    },
    [PHRASE_TYPE_SEARCH] ({dispatch, state, commit}, params) {
      var loadparams = true
      var data = {'mode': 'phrase_type_search'}
      if (params) {
        if (params.loadparams) {
          loadparams = params.loadparams
        }
      }
      dispatch('apiGet', {url: '/phrases', data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PHRASE_TYPE_SEARCH_FAILURE, res.data)
          } else {
            commit(PHRASE_TYPE_SEARCH_SUCCESS, res.data)
          }
        }
      })
    },
    [PHRASE_SAVE] ({dispatch, state, commit}, params) {
      var loadparams = 'block'
      var data = params.data
      var callbackFunc = params.callback

      dispatch('apiPost', {url: '/phrases/save', data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PHRASE_SAVE_FAILURE, res.data)
          } else {
            res.data['callback'] = callbackFunc
            commit(PHRASE_SAVE_SUCCESS, res.data)
          }
        }
      })
    },
    [PHRASE_USE] ({dispatch, state, commit}, params) {
      var loadparams = ''
      var data = params.data
      var callbackFunc = params.callback

      dispatch('apiPatch', {url: '/phrases/use', data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PHRASE_USE_FAILURE, res.data)
          } else {
            res.data['callback'] = callbackFunc
            commit(PHRASE_USE_SUCCESS, res.data)
          }
        }
      })
    },
    [PHRASE_DELETE] ({dispatch, state, commit}, params) {
      var url = '/phrases/' + params.phraseId
      var loadparams = 'block'
      var callbackFunc = params.callback

      dispatch('apiDelete', {url: url, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 204 || res.status === 304) {
          if (res.data.error) {
            commit(PHRASE_DELETE_FAILURE, res.data)
          } else {
            res.data['callback'] = callbackFunc
            commit(PHRASE_DELETE_SUCCESS, res.data)
          }
        }
      })
    }
  },
  mutations: {
    [PHRASE_SEARCH_FAILURE] (state, data) {
      console.log('PHRASE_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [PHRASE_SEARCH_SUCCESS] (state, params) {
      console.log('PHRASE_SEARCH_SUCCESS')
      var data = params.data
      var reSearch = false

      if (data.isCombobox) {
        state.phrases = {}
        state.phraseLists = {}
        data.data.forEach(o => {
          if (!(o.attributes['phrase-type-id'] in state.phraseLists)) {
            state.phraseLists[o.attributes['phrase-type-id']] = []
          }
          state.phraseLists[o.attributes['phrase-type-id']].push(o)
        })
      } else {
        data.data.forEach(o => {
          if (!(o.attributes['phrase-type-id'] in state.phrases)) {
            state.phrases[o.attributes['phrase-type-id']] = []
          }
          state.phrases[o.attributes['phrase-type-id']].push(o)
        })
      }

      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }

      if (reSearch) {
        // 再検索
        state.uncategorizedPhrases = data.data
        if (data.meta['next-page'] === null) {
          // 次へのリンクが無かったら
          state.phrasesCurrentPage = null
        }
      } else {
        if (data.meta) {
          if (data.meta['current-page'] && data.meta['current-page'] > 1) {
            state.uncategorizedPhrases = state.uncategorizedPhrases.concat(data.data)
            state.phrasesCurrentPage = data.meta['current-page']
          } else {
            state.uncategorizedPhrases = data.data
            state.phrasesCurrentPage = 1
          }
        }
        if (data.links && data.links['next']) {
          state.phrasesNextPage = data.links['next']
        } else {
          state.phrasesNextPage = null
        }
      }
      if (data.meta && data.meta['total-count'] !== null) {
        state.phrasesTotalCount = data.meta['total-count']
      }

      if (params.callback) {
        params.callback()
      }
    },
    [PHRASE_CLEAR] (state) {
      state.phrases = {}
      state.uncategorizedPhrases = null
    },
    [PHRASE_TYPE_SEARCH_FAILURE] (state, data) {
      console.log('PHRASE_TYPE_SEARCH_FAILURE')
    },
    [PHRASE_TYPE_SEARCH_SUCCESS] (state, data) {
      console.log('PHRASE_TYPE_SEARCH_SUCCESS')
      state.phraseTypes = data.data
    },
    [PHRASE_SAVE_FAILURE] (state, data) {
      console.log('PHRASE_SAVE_FAILURE')
      // 通知
      state.phrasesNotify = {
        danger: true,
        message_i18n: 'messages.save.danger'
      }
      setTimeout(() => {
        state.phrasesNotify = null
      }, constant.notifyShowTime.normal)
    },
    [PHRASE_SAVE_SUCCESS] (state, data) {
      console.log('PHRASE_SAVE_SUCCESS')
      if (data['callback'] != null) {
        data['callback']()
      }
      // 通知
      state.phrasesNotify = {
        success: true,
        message_i18n: 'messages.save.success'
      }
      setTimeout(() => {
        state.phrasesNotify = null
      }, constant.notifyShowTime.normal)
    },
    [PHRASE_USE_FAILURE] (state, data) {
      console.log('PHRASE_USE_FAILURE')
    },
    [PHRASE_USE_SUCCESS] (state, data) {
      console.log('PHRASE_USE_SUCCESS')
      if (data['callback'] != null) {
        data['callback']()
      }
    },
    [PHRASE_DELETE_FAILURE] (state, data) {
      console.log('PHRASE_DELETE_FAILURE')
      // 通知
      state.phrasesNotify = {
        danger: true,
        message_i18n: 'messages.delete.danger'
      }
      setTimeout(() => {
        state.phrasesNotify = null
      }, constant.notifyShowTime.normal)
    },
    [PHRASE_DELETE_SUCCESS] (state, data) {
      console.log('PHRASE_DELETE_SUCCESS')
      if (data['callback'] != null) {
        data['callback']()
      }
      // 通知
      state.phrasesNotify = {
        success: true,
        message_i18n: 'messages.delete.success'
      }
      setTimeout(() => {
        state.phrasesNotify = null
      }, constant.notifyShowTime.normal)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/phrase.js